module.exports = __webpack_public_path__ + "assets/0c633226f3af51dfc747e8d2bdcbec4b.png";